import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import { useParent } from '../_load/ParentLoader'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Input from '../../../../packages/kiti/components/form/Input'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Switch from '../../../../components/form/Switch'

const ParentSection = () => {
  const parent = useParent()
  if (!parent?.id) return false

  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        Hierarquia
      </Title>
      <Line />
      <Separator weight={4} />

      <Grid paddingGutter={0.5} wrap>
        <Col width="50%">
          <FormItem label="Abrindo como atividade filha de:">
            <Input value={`${parent?.yearlyId} - ${parent?.checklist?.name}`} disabled />
          </FormItem>
        </Col>

        <Col width="50%">
          <FormItem label="Transformar pai em pendente" field="parentDependent" Input={Switch} />
        </Col>
      </Grid>
    </>
  )
}

export default ParentSection
